import { Capacitor } from "@capacitor/core";

const LAST_RELOAD_KEY = "staleChunkReloadAt";
const RELOAD_COOLDOWN_MS = 10_000;

// After a deploy, tabs opened on the previous build request hashed chunks that
// no longer exist. Reload once to fetch the new index.html and its assets.
export const reloadOnStaleChunk = () => {
  // Native builds bundle their assets; reloading won't help there
  if (Capacitor.isNativePlatform()) {
    return;
  }

  window.addEventListener("vite:preloadError", (event) => {
    const lastReloadAt = Number(sessionStorage.getItem(LAST_RELOAD_KEY) ?? 0);

    // Guard against reload loops if the asset is really missing
    if (Date.now() - lastReloadAt < RELOAD_COOLDOWN_MS) {
      return;
    }

    event.preventDefault();
    sessionStorage.setItem(LAST_RELOAD_KEY, String(Date.now()));
    window.location.reload();
  });
};
